import { PLACEHOLDER_BUTTON__bar_8_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_8_5';
import { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { ENUM__token_type } from '@shared/dto/generation/graph_invoke/_fields/token/ENUM__token_type';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { G_BUTTON__field_use_as_grid2d_column } from '../../_base/_buttons/G_BUTTON__field_use_as_grid2d_column';
import { G_BUTTON__field_use_as_grid2d_row } from '../../_base/_buttons/G_BUTTON__field_use_as_grid2d_row';
import { G_UI_FIELD__header_icon_lock } from '../../_base/G_UI_FIELD__header_icon_lock';
import { G_UI_FIELD__info } from '../../_base/G_UI_FIELD__info';
import { G_VIEW__token_related_words_buttons } from '../_archive/prompt_token/_buttons/related_words/G_VIEW__token_related_words_buttons';
import { G_BUTTON__token_change_sign } from './_buttons/G_BUTTON__token_change_sign';
import { G_BUTTON__token_delete } from './_buttons/G_BUTTON__token_delete';
import { G_BUTTON__token_drag_handle } from './_buttons/G_BUTTON__token_drag_handle';
import { G_BUTTON__token_edit } from './_buttons/G_BUTTON__token_edit';
import { G_BUTTON__token_update_visibility } from './_buttons/G_BUTTON__token_update_visibility';
import { G_UI_FIELD__token_list_item_header_word } from './G_UI_FIELD__token_list_item_header_word';

interface Props {
  field: FIELD__token;
  field_parent: FIELD__list_token;
  is_mouse_hovered: boolean;
  dragHandleProps: DraggableProvidedDragHandleProps | null;
}

export function G_UI_FIELD__token_list_item_header({ field, is_mouse_hovered, field_parent, dragHandleProps }: Props) {
  /*
   * STORE
   */
  /*
   * STATE
   */

  /*
   * METHODS
   */

  function get_info_at_begin() {
    let out = new MAP__serializable<string, string>();
    out.set('content', field.word_english.get_value());
    out.set('type', field.type);

    return out;
  }

  /*
   * RENDERS
   */

  function render_header_with_name() {
    if (is_mouse_hovered) return null;

    return (
      <div className={`px-1 size-full flex items-center justify-between text-xs text-left text-bar-foreground`}>
        <span className=" flex items-center gap-1">
          <G_BUTTON__token_drag_handle {...{ field_parent }} {...{ dragHandleProps }} />
          <G_UI_FIELD__info {...{ field }} info_at_begin={get_info_at_begin()} />
          {render_token_order()}
          <G_UI_FIELD__token_list_item_header_word {...{ field }} />
        </span>
        <G_UI_FIELD__header_icon_lock {...{ field }} />
      </div>
    );
  }

  function render_token_order() {
    if (field_parent.tokens_are_independent_to_each_other) return null;
    if (field.is_hidden.get_value()) return null;

    let used_tokens = field_parent.get_enabled_and_non_zero_weight_items();

    let index = used_tokens.findIndex(item => item.meta.field_id == field.meta.field_id);

    return <span>{index + 1}.</span>;
  }

  function render_buttons_dimensions() {
    if (field.type == ENUM__token_type.EMBEDDING)
      return (
        <>
          <PLACEHOLDER_BUTTON__bar_8_5 />
          <PLACEHOLDER_BUTTON__bar_8_5 />
        </>
      );

    return (
      <>
        <G_BUTTON__field_use_as_grid2d_column field={field.weight} />
        <G_BUTTON__field_use_as_grid2d_row field={field.weight} />
      </>
    );
  }

  function render_header_with_actions() {
    if (!is_mouse_hovered) return null;

    return (
      <div className="size-full flex flex-row items-center justify-between px-1">
        <G_BUTTON__token_drag_handle {...{ field_parent }} {...{ dragHandleProps }} />
        <G_UI_FIELD__info {...{ field }} info_at_begin={get_info_at_begin()} />
        {/* todo: edit token -> show input, hide input on token changed */}
        {/* todo: animate word if word too long */}
        <G_BUTTON__token_edit {...{ field }} />
        <G_BUTTON__token_change_sign {...{ field }} />
        <G_VIEW__token_related_words_buttons {...{ field }} />
        {render_buttons_dimensions()}

        <G_BUTTON__token_delete {...{ field }} />
        <G_BUTTON__token_update_visibility {...{ field }} />
      </div>
    );
  }

  /*
   * HTML
   */

  return (
    <div className="w-full h-5 ">
      {render_header_with_actions()}
      {render_header_with_name()}
    </div>
  );
}
